import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

import Select from "components/elements/Select";
import {
  USER_CLIENT_ADMIN,
  USER_CLIENT_ENDUSER,
  CLIENT_BROADCASTER,
} from "core/Constants";

import Table from "components/elements/Table";
import IconButton from "components/elements/IconButton";
import dataProvider from "core/DataProvider";
import Modal from "components/elements/Modal";
import { useOutletContext } from "react-router-dom";

import { ReactComponent as EyeIcon } from "../../../images/eye.svg";
import { ReactComponent as AddIcon } from "../../../images/add.svg";

const uaHeader = {
  advertiser: "Advertiser",
  brands: "Brands",
  action: "Action",
};

const AddClientUser = props => {
  const [activeTab, setActiveTab] = useState(0);
  const [formVisible, setFormVisible] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [userType, setUserType] = useState(null);

  const [advertiser, setAdvertiser] = useState("");
  const [advertisers, setAdvertisers] = useState([]);
  const [brand, setBrand] = useState("");
  const [brands, setBrands] = useState([]);

  const [dataList, setDataList] = useState([]);
  const [channels, setChannels] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [userID, setUserID] = useState(null); // Initialize state for userID

  const { token } = useOutletContext();

  const fetchEditData = async userId => {
    try {
      const res = await dataProvider.network.get(
        `clientadvertiserbrandperimission/${userId}`
      );

      const advertisers = {};
      res.forEach(item => {
        if (!advertisers[item.AdvertiserID]) {
          advertisers[item.AdvertiserID] = {
            advertiser: {
              label: item.AdvertiserName,
              value: item.AdvertiserID,
            },
            brands: [],
          };
        }
        // Extract values from the BrandID and BrandName objects
        const brandIDValue = item.BrandID.Valid ? item.BrandID.Int32 : null;
        const brandNameValue = item.BrandName.Valid
          ? item.BrandName.String
          : "";
        advertisers[item.AdvertiserID].brands.push({
          label: brandNameValue,
          value: brandIDValue,
        });
      });

      const formattedDataList = Object.values(advertisers);
      console.log("editdata", formattedDataList);
      setDataList(formattedDataList);
    } catch (error) {
      console.error("Error fetching edit data:", error);
      toast.error("Failed to fetch edit data");
    }
  };

  const cancel = () => {
    setFormVisible(false);
    props.cancel();
  };

  const fetchChannels = async () => {
    console.log("usertype", token.client_type);
    if (token.client_type === CLIENT_BROADCASTER) {
      try {
        let channels = [];
        let res = await dataProvider.network.get("min-master/channels");

        for (let i = 0; i < res.length; i++) {
          channels.push({ ...res[i], selected: false });
        }
        setChannels(channels);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch channels");
      }
    }
  };

  const addUser = async () => {
    let error = "";

    if (!name || !name.length || name.length < 2) {
      error = "Invalid name, must be at least 3 character long";
    }

    if (!email || !email.length || !email.includes("@")) {
      error = "Invalid email, please provide a valid email address";
    }

    if (!userType || !userType.value) {
      error = "Please select a user type";
    }
    if (token.client_type !== 2) {
      if (!dataList || !dataList.length) {
        error = "Please select some advertiser & brands in access rights tab";
      }
    }

    if (error.length) {
      toast.error(error);
      return;
    }

    let dl = dataList.map(x => ({
      advertiser_id: x.advertiser.value,
      brands: x.brands.map(y => y.value),
    }));

    const data = {
      id: userID ? userID : 0, // This will be undefined if adding a new user
      name,
      email,department:null,
      client_id: token.client_id,
      user_type: userType.value,
      access: dl,
    };

    try {
      await dataProvider.network.post("users/add", data);

      setFormVisible(false);

      // reset form
      setName("");
      setEmail("");
      setUserType(null);
      setAdvertiser(null);
      setBrands([]);
      setDataList([]);
      // Display success message based on whether it's an update or a create
      if (userID) {
        toast.success("User updated successfully");
      } else {
        toast.success("User created successfully");
      }
      // reset form
      setName("");
      setEmail("");
      setUserType(null);
      setAdvertiser(null);
      setBrands([]);
      setDataList([]);
      setUserID(""); // Clear the userID
      props.onComplete();
    } catch (error) {
      console.error(error);
      toast.error("Failed to create user");
    }
  };

  const loadAdvertisers = async () => {
    try {
      let advs = await dataProvider.network.get(
        "min-master/group-advertisersforaddedituser?group-id=" + token.group_id
      );
      advs = advs.map(x => ({ label: x.name, value: x.id }));

      setAdvertisers(advs);
    } catch (error) {
      toast.error("Failed to load advertisers");
    }
  };

  const loadBrands = async () => {
    try {
      let brands = await dataProvider.network.post(
        "min-master/brandbyadvertisercode",
        {
          advertisers: [parseInt(advertiser.value)],
        }
      );
      let brandListing = [
        { label: "All", value: -1 },
        ...brands.map(x => ({ label: x.name, value: x.id })),
      ];

      setBrands(brandListing);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load brands");
    }
  };

  const addBrand = brand => {
    let dl = [...dataList];

    let foundIndex = -1;
    for (let i = 0; i < dl.length; i++) {
      if (dl[i].advertiser.value === advertiser.value) {
        foundIndex = i;
        break;
      }
    }

    // all case
    if (brand.value < 0 && foundIndex > -1) {
      dl[foundIndex].brands = [];
    }
    if (brand.value < 0 && foundIndex < 0) {
      dl.push({ advertiser, brands: [] });
    }
    if (brand.value > 0 && foundIndex > -1) {
      dl[foundIndex].brands.push(brand);
    }
    if (brand.value > 0 && foundIndex < 0) {
      dl.push({ advertiser, brands: [brand] });
    }

    setDataList(dl);
    setBrand("");
  };

  const selectAllChannels = () => {
    let newList = [];
    for (let i = 0; i < channels.length; i++) {
      newList.push({ ...channels[i], selected: true });
    }
    setChannels(newList);
  };

  const removeAllChannels = () => {
    let newList = [];
    for (let i = 0; i < channels.length; i++) {
      newList.push({ ...channels[i], selected: false });
    }
    setChannels(newList);
  };

  const addChannel = dindex => {
    let newList = [...channels];
    newList[dindex].selected = true;
    setChannels(newList);
  };

  const removeChannel = dindex => {
    let newList = [...channels];
    newList[dindex].selected = false;
    setChannels(newList);
  };

  const getTableView = data => {
    let tableData = [];
    for (let i = 0; i < data.length; i++) {
      tableData.push({
        advertiser: data[i].advertiser.label,
        brands: data[i].brands.length
          ? `Selected (${data[i].brands.length})`
          : "All",
        action: (
          <div className="flex">
            {data[i].brands.length > 0 && (
              <div
                className="action-button flex flex-center"
                title="view"
                onClick={() => showSelectedBrands(data[i].brands)}
              >
                <EyeIcon />
              </div>
            )}
            <div
              className="action-button flex flex-center"
              title="Delete"
              onClick={() => removeAdvertiserEntry(data[i].advertiser.value)}
            >
              <AddIcon style={{ transform: "rotate(45deg)" }} />
            </div>
          </div>
        ),
      });
    }

    return tableData;
  };

  const showSelectedBrands = brands => {
    let content = (
      <Modal onClose={() => setModalData(null)}>
        <div className="flex">
          <div className="row">
            <h2>Brands</h2>
          </div>
        </div>
        <div
          className="flex mtop"
          style={{ minWidth: "30vw", minHeight: "40vh", maxHeight: "50vh" }}
        >
          <div
            className="row sub-preview-lists"
            style={{ paddingRight: "0", marginLeft: "0" }}
          >
            <div className="item-lists" style={{ maxHeight: "100%" }}>
              {brands.map((item, idx) => (
                <div className="row full-row" key={idx}>
                  {item.label}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal>
    );

    setModalData(content);
  };

  const removeAdvertiserEntry = advertiserId => {
    let newList = [];
    for (let i = 0; i < dataList.length; i++) {
      if (dataList[i].advertiser.value !== advertiserId) {
        newList.push(dataList[i]);
      }
    }

    setDataList(newList);
  };

  let selectedChannels = [];
  let notSelectedChannels = [];
  for (let i = 0; i < channels.length; i++) {
    if (channels[i].selected) {
      selectedChannels.push({ ...channels[i], dindex: i });
    } else {
      notSelectedChannels.push({ ...channels[i], dindex: i });
    }
  }
  const selectedBrandIds = dataList.flatMap(entry =>
    entry.brands.map(brand => brand.value)
  );
  console.log("dataofbrand", selectedBrandIds);
  const accessRightTab = {
    advertiser_selector: (
      <div className="tab-body">
        <div className="prow flex flex-v-center">
          <div className="el flex-full">
            <Select
              placeholder="Advertiser"
              value={advertiser}
              options={advertisers}
              onChange={e => setAdvertiser(e)}
            />
          </div>
          <div className="el flex-full">
            <Select
              placeholder="Brand"
              value={brand}
              options={brands.filter(x => !selectedBrandIds.includes(x.value))}
              onChange={e => addBrand(e)}
            />
          </div>
        </div>
        <div className="prow" style={{ margin: "1rem", padding: "1rem 0" }}>
          <Table headers={uaHeader} data={getTableView(dataList)} />
        </div>
      </div>
    ),
    channel_selector: (
      <div className="tab-body" style={{ padding: "0 1rem" }}>
        <div className="mtop flex item-selector">
          <div className="flex flex-col col flex-full">
            <div className="el flex flex-v-center">
              <div className="item-label bold">All Channels</div>
              <div className="item-action">
                <IconButton icon="add" onClick={selectAllChannels} />
              </div>
            </div>
            {notSelectedChannels.map((ch, idx) => (
              <div className="el flex flex-v-center item-row" key={idx}>
                <div className="item-label">{ch.label}</div>
                <div className="item-action">
                  <IconButton icon="add" onClick={_ => addChannel(ch.dindex)} />
                </div>
              </div>
            ))}
          </div>
          <div className="flex flex-col col flex-full">
            <div className="el flex flex-v-center">
              <div className="item-label bold">Selected Channels</div>
              <div className="item-action">
                <IconButton icon="remove" onClick={removeAllChannels} />
              </div>
            </div>
            {selectedChannels.map((ch, idx) => (
              <div className="el flex flex-v-center item-row" key={idx}>
                <div className="item-label">{ch.label}</div>
                <div className="item-action">
                  <IconButton
                    icon="remove"
                    onClick={_ => removeChannel(ch.dindex)}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    ),
  };

  const tabData = [
    {
      title: "User Details",
      content: (
        <div className="tab-body">
          <div className="prow flex flex-v-center">
            <div className="el flex-full">
              <input
                type="text"
                placeholder="Name"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div className="el flex-full">
              <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="prow flex flex-v-center">
            <div className="el flex-full">
              <Select
                value={userType}
                onChange={e => setUserType(e)}
                placeholder="Type"
                options={[
                  { label: "Admin", value: USER_CLIENT_ADMIN },
                  { label: "End User", value: USER_CLIENT_ENDUSER },
                ]}
              />
            </div>
            <div className="el flex-full"></div>
          </div>
        </div>
      ),
    },
    {
      title: "Access Rights",
      content:
        accessRightTab[
          token.client_type === CLIENT_BROADCASTER
            ? "channel_selector"
            : "advertiser_selector"
        ],
    },
  ];

  useEffect(() => {
    if (token.client_type === CLIENT_BROADCASTER) {
      fetchChannels();
    }
    loadAdvertisers();
  }, [token]);

  useEffect(() => {
    if (advertiser && advertiser.value) {
      loadBrands();
      setBrand("");
    }
  }, [advertiser]);

  useEffect(() => {
    if (props.editUser) {
      setUserID(props.editUser.id);
      setName(props.editUser.name);
      setEmail(props.editUser.email);
      setUserType({
        label: props.editUser.user_type,
        value: props.editUser.user_type_int,
      });
      setFormVisible(true);
      fetchEditData(props.editUser.id);
    }
  }, [props.editUser]);

  return (
    <div>
      {modalData && modalData}
      <div className="flex">
        <div className="right flex flex-v-center">
          {formVisible ? (
            <>
              <IconButton text="Save" onClick={addUser} />
              <IconButton text="Cancel" onClick={cancel} />
            </>
          ) : (
            <IconButton
              icon="add"
              text="New User"
              onClick={() => setFormVisible(true)}
            />
          )}
        </div>
      </div>
      {formVisible && (
        <div className="box mtop pad-1">
          <div className="tabs">
            {tabData.map((tab, index) => (
              <div
                key={index}
                className={activeTab === index ? "tab-head active" : "tab-head"}
                onClick={_ => setActiveTab(index)}
              >
                {tab.title}
              </div>
            ))}
          </div>
          <div className="tab-content">{tabData[activeTab].content}</div>
        </div>
      )}
    </div>
  );
};

export default AddClientUser;
